import { useAuth } from "../../../data/context/auth-context";

const Username = () => {
  const { isAuthenticated, profile } = useAuth();

  if (!isAuthenticated || !profile) {
    return null;
  }

  return <div>{profile.name}</div>;
};

export default Username;
